import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/finish-line-video-analytics.mp4")